import React, { useState } from "react";
import CountUp from "react-countup";
import ScrollTrigger from "react-scroll-trigger";
import "./srilanka.css";

export default function Female() {
  const [counterOn, setCounterOn] = useState(false);
  return (
    <ScrollTrigger
      onEnter={() => setCounterOn(true)}
      onExit={() => setCounterOn(false)}
    >
      <br />
      <div className="sri-lanka-box1">
        {counterOn && <CountUp start={0} end={9} duration={3} delay={0.3} />}
      </div>
      <br />
      <div className="sri-lanka-box2">
        {counterOn && <CountUp start={0} end={4353} duration={3} delay={0.3} />}
      </div>
      <br />
      <div className="sri-lanka-box3">
        {counterOn && <CountUp start={0} end={4488} duration={3} delay={0.3} />}
      </div>
      <br />
      <div className="sri-lanka-box4">
        {counterOn && <CountUp start={0} end={54} duration={3} delay={0.3} />}%
      </div>
    </ScrollTrigger>
  );
}
